import { useCallback, useContext, useEffect, useState } from "react";
import { authorOption, robotsOption, statusOption } from "../../../constant";
import { useService } from "../../../hooks";
import { NavigatorContext } from "../../../context";

export const useEvent = () => {
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr } = useService("Data", "event");
  const { setTitle } = useService("Meta");
  const { isEmpty } = useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const [, setactiveRobotsIndex] = useState<number>(0);
  const [, setactiveStatusIndex] = useState<number>(0);
  const [, setactiveAuthorIndex] = useState<number>(0);
  const [image, setimage] = useState([]);
  const [, setuid] = useState<string>("");
  const [title, settitle] = useState<string>("");
  const [slug, setslug] = useState<string>("");
  const [content, setcontent] = useState<string>("");
  const [, setexcerpt] = useState<string>("");
  const [, setcss] = useState<string>("");
  const [, setjs] = useState<string>("");
  const [, setcanonical] = useState<string>("");
  const [, setrobots] = useState<string>("");
  const [, setmetaDescription] = useState<string>("");
  const [, setmetaKeyword] = useState(null);
  const [, setauthor] = useState<string>("");
  const [publishDate, setpublishDate] = useState(new Date());
  const [, setstatus] = useState(null);
  const [category, setcategory] = useState([]);
  const [, settag] = useState(null);

  const urlData = urlToSplitData(getLocationData().pathname);
  const urlSlug = urlData[2];

  const getEventData = useCallback(async (query) => {
    const result = await fetchByAttr(query);
    if (result.status) {
      if (result.data[0].status !== "publish")
        navigateTo({ route: "/error404" });
      else {
        const eventData = result.data[0];
        setactiveAuthorIndex(
          authorOption.findIndex((e) => e.value === eventData.robots)
        );
        setactiveRobotsIndex(
          robotsOption.findIndex((e) => e.value === eventData.robots)
        );
        setactiveStatusIndex(
          statusOption.findIndex((e) => e.value === eventData.status)
        );
        settag(isEmpty(eventData.tag) ? [] : JSON.parse(eventData.tag));
        setcategory(
          isEmpty(eventData.category) ? [] : JSON.parse(eventData.category)
        );
        setmetaKeyword(
          isEmpty(eventData.metaKeyword)
            ? []
            : JSON.parse(eventData.metaKeyword)
        );
        setTitle(eventData.title);
        settitle(eventData.title);
        setslug(eventData.slug);
        setcontent(eventData.content);
        setexcerpt(eventData.excerpt);
        setcss(eventData.css);
        setjs(eventData.js);
        setcanonical(eventData.canonical);
        setrobots(eventData.robots);
        setmetaDescription(eventData.metaDescription);
        setauthor(eventData.author);
        setpublishDate(new Date(eventData.publishDate));
        setstatus(eventData.status);
        setuid(eventData.uid);
        setimage(JSON.parse(eventData.image));
      }
    }
  }, [fetchByAttr, isEmpty, navigateTo, setTitle]);

  useEffect(() => {
    if (slug !== urlSlug) getEventData({ slug: urlSlug });
  }, [slug, urlSlug, getEventData]);
  return {
    category: category.join(", "),
    title,
    publishDate,
    image,
    content,
    slug,
  };
};
